import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";
import JsonData from "../data/data.json";

const SLIDER_SETTINGS = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  adaptiveHeight: false,
  centerMode: false,
  variableWidth: false,
};

const openInNewTab = () => {
  const domain = JsonData?.Header?.nameBankDomain || "cofisapagamentos";
  window.open(`https://app.${domain}.com.br/register`, "_blank", "noreferrer");
};

const SlideItem = ({ slide, openAccountLabel }) => (
  <div className="slide-wrapper">
    <div className="slide-image">
      <img
        src={slide.image}
        alt={slide.title}
        loading="lazy"
        className="slide-img"
      />
      <div className="overlay">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-xs-12 intro-text">
              <h1 className="upp">{slide.title}</h1>
              {slide.protectedText && (
                <p className="protected-text">{slide.protectedText}</p>
              )}
              <p className="subtitle m-top m-bottom">{slide.subtitle}</p>
              <button className="btn btn-custom btn-lg" onClick={openInNewTab}>
                {openAccountLabel}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const Slidershow = () => {
  const { t } = useTranslation("landing");
  const brand = JsonData?.About?.nameBank || "COFISA";
  const slides = t("slides.items", { returnObjects: true, brand });
  const openAccountLabel = t("slides.openAccount");
  const slideList = Array.isArray(slides) ? slides : [];

  if (slideList.length === 1) {
    return (
      <div className="slideshow">
        <SlideItem slide={slideList[0]} openAccountLabel={openAccountLabel} />
      </div>
    );
  }

  return (
    <div className="slideshow">
      <Slider {...SLIDER_SETTINGS}>
        {slideList.map((slide, index) => (
          <SlideItem key={index} slide={slide} openAccountLabel={openAccountLabel} />
        ))}
      </Slider>
    </div>
  );
};
